import { createFileRoute } from '@tanstack/react-router'
import { TemplateManager } from '@/modules/proposal-builder/components/templates/TemplateManager'

export const Route = createFileRoute('/proposal-builder/templates/')({
  component: ProposalTemplatesIndexRoute,
})

function ProposalTemplatesIndexRoute() {
  return <TemplateManager />
}